// polyfills for dynamic import
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

// dynamically import platform-specific files before launching main React app
import(`./platforms/${process.env.REACT_APP_PLATFORM}`).then((module) => {
  module.default();
});
